<template>
    <div id="listing-view">
        <flash-message transitionIn="animated swing"></flash-message>
        <b-row>
            <b-col xs="12" lg="12">
                <b-card>
                    <div slot="header">
                        {{ person.name }} {{ person.surname }}
                    </div>
                    <b-tabs >
                        <b-tab active>
                            <template slot="title">
                                <i class="icon-list"></i> Details
                            </template>
                            <h3>Edit details</h3>
                            <person-form :person="person" :edit-option="true"></person-form>
                        </b-tab>
                      <b-tab>
                        <template slot="title">
                          <i class="icon-envelope-open"></i> News Letter Subscriptions
                        </template>
                        <h3>Subscriptions</h3>
                        <subscription-table :subscriptions="person.listingSubscription"></subscription-table>
                      </b-tab>
                      <b-tab>
                        <template slot="title">
                          <i class="icon-organization"></i> Memberships
                        </template>
                        <h3>Memberships</h3>
                        <membership-table :memberships="person.membership"></membership-table>
                      </b-tab>
                    </b-tabs>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>

    import {Person} from "../../models/Person";
    import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
    import PersonForm from "../../components/person/PersonForm";
    import SubscriptionTable from "../../components/newsletter/Subscription/SubscriptionTable";
    import MembershipTable from "../../components/membership/MembershipTable";

    export default {
        name: 'person',
        components: {
          MembershipTable,
          SubscriptionTable,
          PersonForm
        },
        data (){
            return {
                person: new Person(),
                personId: this.$route.params.person_id,
            }
        },
        mounted () {
          RepositoryFactory
            .get('people')
            .getPerson(this.personId)
            .then(
              response => (
                this.person = new Person(response.data.data)
              )
            )
        },
    }
</script>
